/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from './StatusBadge';
import { ENVIRONMENT_LABELS } from '../constants';

// Ambiente da credencial. Produção ganha âmbar de atenção — é a chave que
// fatura de verdade; sandbox fica neutro (não cobra ninguém).
export default function EnvironmentBadge({ value }) {
   const label = ENVIRONMENT_LABELS[value] ?? value ?? '—';
   return (
      <StatusBadge variant={value === 'production' ? 'amber' : 'neutral'}>
         {label}
      </StatusBadge>
   );
}

EnvironmentBadge.propTypes = {
   value: PropTypes.string,
};
